export default __webpack_public_path__ + "static/media/call-you-mine.71b1faa4.jpg";